var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { loginAPI, logoutAPI } from '@/api/login.js';
import { userListAPI, depListAPI, adminUserQueryOrgInfoAPI, adminIndexAuthListAPI } from '@/api/common.js';
import { adminUserGetOauthUrl, adminUserOauthNotify } from '@/api/config.js';
import { resetRouter } from '@/router';
import { adminUsersReadAPI } from '@/api/user/personCenter.js';
import { addAuth, removeAuth } from '@/utils/auth';
import cache from '@/utils/cache';
import Lockr from 'lockr';
import { debounce } from 'throttle-debounce';
import Cookies from 'js-cookie';
import axios from 'axios';
// import store from '@/store'
import { getCookiesDomain, objDeepCopy } from '@/utils/index.js';
import { Message } from 'element-ui';
function loopUserDeptMap(list, map, userList, deptList) {
    list.forEach(function (item) {
        map["dept-" + item.deptId] = item;
        deptList.push(item); // 添加部门搜索数据源
        if (item.userList) {
            item.userList.forEach(function (user) {
                map["user-" + user.userId] = user;
                userList.push(user); // 添加员工搜索数据源
            });
        }
        if (item.children) {
            loopUserDeptMap(item.children, map, userList, deptList);
        }
    });
}
var user = {
    state: {
        userInfo: {},
        // 权限信息
        allAuth: {},
        userDeptObj: {
            disableUserList: [],
            userMap: {},
            deptList: []
        },
        userDeptMap: {},
        searchUserDept: {
            userList: [],
            deptList: [],
            disableUserList: []
        },
        userList: [],
        deptList: [],
        crm: {},
        bi: {},
        manage: {},
        oa: {},
        call: false // 呼叫中心是否开启
    },
    mutations: {
        SET_USERINFO: function (state, userInfo) {
            state.userInfo = userInfo;
            localStorage.setItem('loginUserInfo', JSON.stringify(userInfo));
        },
        SET_ALLAUTH: function (state, allAuth) {
            state.allAuth = allAuth;
        },
        SET_CRM: function (state, crm) {
            state.crm = crm;
        },
        SET_BI: function (state, bi) {
            state.bi = bi;
        },
        SET_MANAGE: function (state, manage) {
            state.manage = manage;
        },
        SET_OA: function (state, oa) {
            state.oa = oa;
        },
        SET_CALL: function (state, call) {
            state.call = call;
        },
        SET_CHANNEL: function (state, data) {
            var channel = data.channel;
            localStorage.setItem('channel', channel);
            var domain = getCookiesDomain();
            Cookies.set('channel', channel, { domain: domain, expires: 365 });
            axios.defaults.headers['channel'] = channel;
        },
        SET_AUTH: function (state, data) {
            var token = data.adminToken;
            var channel = data.channel;
            localStorage.setItem('AdminToken', token);
            localStorage.setItem('channel', channel);
            var domain = getCookiesDomain();
            Cookies.set('AdminToken', token, { domain: domain, expires: 365 });
            Cookies.set('channel', channel, { domain: domain, expires: 365 });
            addAuth({ adminToken: token, channel: channel });
        },
        SET_USERLIST: function (state, data) {
            state.userList = data;
        },
        SET_DEPTLIST: function (state, data) {
            state.deptList = data;
        },
        SET_USERDEPTOBJ: function (state, data) {
            state.userDeptObj = data;
        },
        SET_USERDEPTMAP: function (state, data) {
            var _a;
            var tempMap = {
            // 'dept-0': {
            //   deptId: 0,
            //   name: '全公司'
            // }
            };
            var userList = [];
            var deptList = [];
            loopUserDeptMap((data === null || data === void 0 ? void 0 : data.deptList) || [], tempMap, userList, deptList);
            var disableUserList = [];
            ((_a = data === null || data === void 0 ? void 0 : data.disableUserList) === null || _a === void 0 ? void 0 : _a.forEach(function (user) {
                tempMap["user-" + user.userId] = user;
                disableUserList.push(user);
            })) || [];
            // 同时更新 搜索 和 map
            state.searchUserDept = {
                userList: userList,
                deptList: deptList,
                disableUserList: disableUserList
            };
            state.userDeptMap = tempMap;
        }
    },
    actions: {
        //  获取企业微信授权链接
        GetQywxUrl: function () {
            return new Promise(function (resolve, reject) {
                // 企业微信回调只返回第一个参数，所以token和channel传递通过params=token,channel形式
                var url = process.env.VUE_APP_URL + "?params=" + Cookies.get('AdminToken') + "," + Cookies.get('channel') + "#wechat_redirect";
                adminUserGetOauthUrl({ redirect_url: url }).then(function (_a) {
                    // console.log(`oauthUrl = `, oauthUrl)
                    // oauthUrl = 'https%3A%2F%2Fopen.weixin.qq.com%2Fconnect%2Foauth2%2Fauthorize%3Fappid%3Dwwa44e39ffcec05835%26redirect_uri%3Dhttps%3A%2F%2Fwkkcrm.lanhanba.net%2F%23%2Flogin%2Fqywx%23wechat_redirect'
                    var oauthUrl = _a.data.oauth_url;
                    resolve(decodeURIComponent(oauthUrl));
                }, function (err) {
                    reject(err);
                });
            });
        },
        // 企业微信登陆
        QywxLogin: function (_a, code) {
            var commit = _a.commit;
            console.log(commit);
            return new Promise(function (resolve, reject) {
                adminUserOauthNotify({ code: code }).then(function (res) {
                    Message.success('绑定成功');
                    window.location.href = window.location.protocol + '//' + window.location.host;
                    resolve(res);
                }, function (err) {
                    Message.error('绑定失败，请从企业微信入口进入绑定');
                    reject(err);
                });
            });
        },
        // 登录
        Login: function (_a, userInfo) {
            var commit = _a.commit, dispatch = _a.dispatch;
            var password = userInfo.password;
            var params = objDeepCopy(userInfo);
            params.password = password;
            return new Promise(function (resolve, reject) {
                loginAPI(params).then(function (res) {
                    var data = res.data || {};
                    if (!data.companyList) {
                        commit('SET_AUTH', __assign(__assign({}, data), { channel: userInfo.channel }));
                        dispatch('GetUserInfo');
                    }
                    resolve(res);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        // crm 切换租户
        CrmSwitchTenant: function (_a) {
            var dispatch = _a.dispatch;
            return new Promise(function (resolve, reject) {
                try {
                    dispatch('GetUserInfo');
                    dispatch('getAuth');
                    dispatch('QueryModules');
                    resolve(true);
                }
                catch (_a) {
                    reject(false);
                }
            });
        },
        // 获取权限
        getAuth: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return __awaiter(this, void 0, void 0, function () {
                var data, authData, error_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            data = {};
                            _b.label = 1;
                        case 1:
                            _b.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, adminIndexAuthListAPI({})];
                        case 2:
                            authData = _b.sent();
                            data = authData && authData.data ? authData.data : {};
                            return [3 /*break*/, 4];
                        case 3:
                            error_1 = _b.sent();
                            return [2 /*return*/, Promise.reject(error_1)];
                        case 4:
                            if (data.crm && Object.keys(data.crm).length === 0) {
                                delete data.crm;
                            }
                            Lockr.set('authList', data);
                            data.wkFirstModel = data.firstModel;
                            commit('SET_ALLAUTH', data);
                            commit('SET_CRM', data.crm);
                            commit('SET_BI', data.bi);
                            commit('SET_MANAGE', data.manage);
                            commit('SET_OA', data.oa);
                            // 获取 管理后台 员工和部门信息
                            dispatch('GetUserList');
                            dispatch('GetDeptList');
                            dispatch('GetUserDepMap');
                            return [2 /*return*/, Promise.resolve(data)];
                    }
                });
            });
        },
        // 获取用户信息
        GetUserInfo: function (_a) {
            var commit = _a.commit, dispatch = _a.dispatch;
            return new Promise(function (resolve, reject) {
                adminUsersReadAPI({}).then(function (res) {
                    // // 开启了小程序
                    // if (response && response.hasOwnProperty('cardAuth')) {
                    //   response.data.cardAuth = response.cardAuth
                    // }
                    var resData = res.data || {};
                    var adminToken = resData.adminToken;
                    if (resData.initToken && adminToken) {
                        cache.updateAxiosCache({ token: adminToken });
                    }
                    // 邮件信息 走之前的逻辑
                    commit('SET_USERINFO', resData);
                    dispatch('SystemLogoAndName');
                    resolve(res);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        // 登出
        LogOut: function () {
            return new Promise(function (resolve, reject) {
                logoutAPI().then(function () {
                    /** flush 清空localStorage .rm('authKey') 按照key清除 */
                    removeAuth();
                    resetRouter();
                    resolve(true);
                }).catch(function (error) {
                    removeAuth();
                    resetRouter();
                    reject(error);
                });
            });
        },
        debounceGetUserList: debounce(3000, function (_a) {
            var dispatch = _a.dispatch;
            dispatch('GetUserList');
        }),
        // 管理后台员工列表
        GetUserList: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                userListAPI({
                    pageType: 0
                }).then(function (res) {
                    var _a;
                    commit('SET_USERLIST', ((_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.list) || []);
                    resolve(true);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        GetUserDepMap: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                adminUserQueryOrgInfoAPI({}).then(function (res) {
                    var resData = (res === null || res === void 0 ? void 0 : res.data) || {};
                    commit('SET_USERDEPTOBJ', resData);
                    commit('SET_USERDEPTMAP', resData);
                    resolve(resData);
                }).catch(function (error) {
                    reject(error);
                });
            });
        },
        debounceGetDeptList: debounce(3000, function (_a) {
            var dispatch = _a.dispatch;
            dispatch('GetDeptList');
        }),
        // 管理后台部门列表
        GetDeptList: function (_a) {
            var commit = _a.commit;
            return new Promise(function (resolve, reject) {
                depListAPI({ type: 'tree' }).then(function (res) {
                    commit('SET_DEPTLIST', (res === null || res === void 0 ? void 0 : res.data) || []);
                    resolve(true);
                }).catch(function (error) {
                    reject(error);
                });
            });
        }
    }
};
export default user;
